import React from "react";
import { Button } from "@amzn/awsui-components-react-v3";
import { StackRankOptions } from "../components/CPLSuperset/config/CPLSupersetConfig";
import { currentConfig } from "../../../../common/utils/swiftUtil";
import { STAGE_NAMES } from "../../../../common/constants/swiftConstants";
import { AggregationOperation } from "../../../../interfaces/consumptionPreferenceInterfaces";

export const COLUMN_DEFINITIONS = [
  {
    id: "sfgName",
    header: "Supersets & Logical Groups",
    cell: (e: any) => e.sfgName,
    width: 250,
  },
  {
    id: "stackRackIpn",
    header: "Stack Rank IPN",
    cell: (e: any) => StackRankOptions[e.stackRackIpn],
    width: 150,
  },
  {
    id: "tamStartDate",
    header: "Start Date",
    cell: (e: any) => e.tamStartDate,
    width: 130,
  },
  {
    id: "tamEndDate",
    header: "End Date",
    cell: (e: any) => e.tamEndDate,
    width: 130,
  },
  {
    id: "ownershipCombination",
    header: "Ownership",
    cell: (e: any) => e.ownershipCombination,
    width: 180,
  },
  {
    id: "supplierId",
    header: "Supplier Id",
    cell: (e: any) => e.supplierId,
    width: 150,
  },
  {
    id: "supplierCode",
    header: "Supplier Code",
    cell: (e: any) => e.supplierCode,
    width: 150,
  },
  {
    id: "targetTAM",
    header: "Current TAM %",
    cell: (e: any) => e.targetTAM,
    width: 150,
  },
  {
    id: "currentTAM",
    header: "Target TAM %",
    cell: (e: any) => e.currentTAM,
    width: 150,
  },
  {
    id: "deviationPercent",
    header: "Deviation %",
    cell: (e: any) => e.deviationPercent,
    width: 130,
  },
  {
    id: "manufacturer",
    header: "Manufacturer",
    cell: (e: any) => e.manufacturer,
    width: 150,
  },
  {
    id: "customRankPercentage",
    header: "Custom Rank %",
    cell: (e: any) => e.customRankPercentage,
    width: 150,
  },
  //TODO: once backend changes are ready, will enable this
  // {
  //   id: "deviationReason",
  //   header: "Deviation Reason",
  //   cell: (e: any) => e.deviationReason,
  //   width: 180,
  // },
  // {
  //   id: "quantityAtStart",
  //   header: "Quantity at start",
  //   cell: (e: any) => e.quantityAtStart,
  //   width: 180,
  // },
  {
    id: "currentQuantity",
    header: "Current Quantity",
    cell: (e: any) => e.currentQuantity,
    width: 180,
  },
  {
    id: "quantityConsumed",
    header: "Quantity Consumed",
    cell: (e: any) => e.quantityConsumed,
    width: 180,
  },
  {
    id: "quantityAllocated",
    header: "Quantity Allocated",
    cell: (e: any) => e.quantityAllocated,
    width: 180,
  },
  {
    id: "receivedAge",
    header: "Received Age",
    cell: (e: any) => e.receivedAge,
    width: 150,
  },
  {
    id: "ownershipAge",
    header: "Ownership Age",
    cell: (e: any) => e.ownershipAge,
    width: 150,
  },
  {
    id: "allocationAge",
    header: "Allocation Age",
    cell: (e: any) => e.allocationAge,
    width: 150,
  },
  {
    id: "action",
    header: "Action",
    cell: (e: any) => e.action,
    width: 280,
  },
];

export const redirectConsumptionPreference = (sfgId, gsmName) => {
  return (
    <Button
      href={`https://${window.location.hostname}/inventory-app/unified-inventory-movement/consumption-cpl/superset?sfgId=${encodeURIComponent(sfgId)}&gsm=${gsmName}`}
      variant="inline-link"
    >
      Configure Consumption Preference
    </Button>
  );
};

export const ConsumptionDataKey = "CPLConsumptionData.csv"
export const ConsumptionReportKey = "ConsumptionReport.csv"
export const AllocationReportKey = "result/ProductionVsLooseGearComponentData.csv"

export const getConsumptionReportBucket = () => {
  switch (currentConfig?.STAGE) {
      case STAGE_NAMES.ALPHA:
          return CONSUMPTION_REPORT_BUCKET_MAPPING.ALPHA;
      case STAGE_NAMES.BETA:
          return CONSUMPTION_REPORT_BUCKET_MAPPING.BETA;
      case STAGE_NAMES.PROD:
          return CONSUMPTION_REPORT_BUCKET_MAPPING.PROD;
      default:
          return CONSUMPTION_REPORT_BUCKET_MAPPING.DEV;
  }
}

export enum CONSUMPTION_REPORT_BUCKET_MAPPING {
  ALPHA = "scos-inventory-preferences-monitoring-data-alpha-448049815488",
  BETA = "scos-inventory-preferences-monitoring-data-beta-699475923622",
  PROD = "scos-inventory-preferences-monitoring-data-prod-515966518704",
  DEV = "scos-inventory-preferences-monitoring-data-beta-699475923622"
}

export const graphErrorMessage = "Error while fetching the data. Reload the page and try again.";

export interface selectOptions {
  label: string | undefined ;
  value: string | undefined ;
}

export interface gsmConfigParams {
	gsm : string | undefined | any;
	alias : string | undefined | any;
	superSetFungibleGroupId : string[] | undefined | any;
}

export interface defaultSearchParams {
  selectedSuperSetFungibleGroupId: selectOptions[] | undefined | any;
}

export const getDefaultPreferredSearchCPL = (params) : defaultSearchParams => {
  let superSetFungibleGroupId = params.superSetFungibleGroupId;
  return {
    selectedSuperSetFungibleGroupId: superSetFungibleGroupId ? superSetFungibleGroupId.map((item)=>{
          return { value: item, label: item }
      }):[],
  };
}

export const DefaultSnapshotMonitoringData = {
  deviationPercentage: {
      aggregationCriteriaName: "DEVIATION_PERCENTAGE",
      operation: AggregationOperation.AVERAGE,
      aggregationName: "DEVIATION_PERCENTAGE",
      aggregationField: "DEVIATION_PERCENTAGE",
      field: "SUPERSET_NAME"
  },
  timeToExpiry: {
      aggregationCriteriaName: "TIME_TO_EXPIRY",
      operation: AggregationOperation.TERMS,
      aggregationName: "SUPERSET_END_DATE",
      aggregationField: "SUPERSET_END_DATE",
      field: "SUPERSET_NAME"
  },
  deviationReason: { //TODO: change this according to request
      aggregationCriteriaName: "DEVIATION_REASON",
      operation: AggregationOperation.SUM,
      subOperation: null,
      aggregationName: "SUB_BURNED_INVENTORY",
      aggregationField: "BURNED_INVENTORY",
      field: "All"
  },
  configuredCurrentTAM: {
      aggregationCriteriaName: "CONFIGURED_AND_ACTUAL_TAM",
      operation: AggregationOperation.TERMS,
      aggregationName: "ACTUAL_TAM",
      aggregationField: "ACTUAL_TAM",
      aggregationName2: "CONFIGURED_TAM",
      aggregationField2: "CONFIGURED_TAM",
      field: "LOGICAL_GROUP"
  },
  historicalTAM: {
    aggregationCriteriaName: "BURN_DATE",
    operation: AggregationOperation.DATE_HISTOGRAM,
    aggregationName: "LOGICAL_GROUP",
    aggregationField: "LOGICAL_GROUP",
    aggregationName2: "BURN_QUANTITY",
    aggregationField2: "BURN_QUANTITY",
    field: "BURN_DATE"
},
};

export const TAB_TABLE_VIEW = "table_view";
export const TAB_TREND_VIEW = "trend_view";
export const TAB_SNAPSHOT_VIEW = "snapshot_view";

export enum GRAPH_TYPES {
  DEVIATION_PERCENTAGE = "DEVIATION_PERCENTAGE",
  TIME_TO_EXPIRY = "TIME_TO_EXPIRY",
  CONFIGURED_AND_ACTUAL_TAM = "CONFIGURED_AND_ACTUAL_TAM",
  LOGICAL_GROUP = "LOGICAL_GROUP",
  HISTORICAL_TAM = "HISTORICAL_TAM"
}

export enum GRAPH_REQUEST_TYPES {
  DEVIATION_PERCENTAGE = "deviationPercentage",
  CONFIGURED_CURRENT_TAM = "configuredCurrentTAM",
  TIME_TO_EXPIRY = "timeToExpiry",
  HISTORICAL_TAM = "historicalTAM"
}

export const SUPERSET_ID = "SUPERSET_ID"
export const SUPERSET_NAME = "SUPERSET_NAME"
export const LOGICAL_GROUP = "LOGICAL_GROUP"
export const EXACT_MATCH = "EXACT_MATCH"
export const STRING = "string"
export const ALL = "All"
export const SNAPSHOT = "SNAPSHOT"
export const RANGE = "RANGE"
export const LONG = "long"
export const AVG = "AVG"
export const SUM = "SUM"
export const GSM_NAME = "gsmName"
export const BURN_DATE = "BURN_DATE"
export const LOADING = "loading"
export const FINISHED = "finished"
export const ERROR = "error"